import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessagesService {

  constructor() { }

  private messages: { [key: string]: string } = {
    ERR_0001: 'ERR_0001 | Erro ao consultar lista de banco de dados.',
    ERR_0004: 'ERR_0004 | Erro ao consultar lista de feiras.',
    ERR_0005: 'ERR_0005 | Erro ao tentar excluir feiras.',
    ERR_0006: 'ERR_0006 | Erro ao consultar Lista de gerar contatos.',
    ERR_0007: 'ERR_0007 | Erro ao consultar Lista de contatos gerados.',
    ERR_0008: 'ERR_0008 | Erro ao deletar Lista de contatos gerados.',
    ERR_0009: 'ERR_0009 | Erro ao consultar Lista de lista de contatos gerados.',
    ERR_0010: 'ERR_0010 | Erro ao consultar mensagens para lista de constatos gerados.',
    ERR_0011: 'ERR_0011 | Erro ao consultar lista de contatos qualificados.',
    ERR_0012: 'ERR_0012 | Erro ao consultar gupos de orçamentos.',
    ERR_0013: 'ERR_0013 | Erro ao deletar gupos de orçamentos.',
    ERR_0014: 'ERR_0014 | Erro ao consultar parâmetros de categoria de orçamentos.',
    ERR_0015: 'ERR_0015 | Erro ao consultar projeto em andamento.',
    ERR_0016: 'ERR_0016 | Ocorreu um erro ao tentar atualizar o status do projeto.',
    ERR_0017: 'ERR_0017 | Ocorreu um erro ao consulta lista de projetos realizados.',
    ERR_0018: 'ERR_0018 | Ocorreu um erro ao solicitar assinaturas.',
    ERR_0019: 'ERR_0019 | Erro ao consultar lista de campanhas de email marketing.',
    ERR_0020: 'ERR_0020 | Erro ao consultar lista de emails bloqueados.',
  };

  getMessage(code: string): string {
    return this.messages[code] || 'Erro desconhecido.';
  }
}
